export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            如有片源建议、合作意向或任何问题，欢迎通过以下方式与我们联系
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <a
              href="#contact"
              className="flex flex-col items-center gap-3 p-6 bg-background-100 rounded-xl hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-primary-50 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-500"></i>
              </div>
              <span className="text-sm font-medium text-foreground-800">商务合作</span>
              <span className="text-xs text-foreground-400">商务洽谈与广告投放</span>
            </a>
            <a
              href="#contact"
              className="flex flex-col items-center gap-3 p-6 bg-background-100 rounded-xl hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-accent-50 flex items-center justify-center">
                <i className="ri-movie-line text-xl text-accent-500"></i>
              </div>
              <span className="text-sm font-medium text-foreground-800">片源投稿</span>
              <span className="text-xs text-foreground-400">推荐您想看的影视资源</span>
            </a>
            <a
              href="#contact"
              className="flex flex-col items-center gap-3 p-6 bg-background-100 rounded-xl hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-secondary-50 flex items-center justify-center">
                <i className="ri-question-line text-xl text-secondary-500"></i>
              </div>
              <span className="text-sm font-medium text-foreground-800">问题反馈</span>
              <span className="text-xs text-foreground-400">遇到问题随时告诉我们</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}